export default "__VITE_ASSET__RJwlT6VR__"